import actions from './action_types.js';
import axios from "axios";

export default {
    [actions.MODAL_GENERATE_ROOT_OPERATION_BALANCE_SAVE]: function(store, data) {
        return axios.post('/records/generated-balance/store-for-global-contractor', data)
            .catch(error => console.log(error))
    }
}
